module.exports = __webpack_public_path__ + "static/free-time-clocks-app-352b5f8b3fc1c3efc366c7b67c468abd.png";